import * as Sentry from '@sentry/nextjs';
import appConfig from './config/appConfig';

Sentry.init({
  dsn: appConfig.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: appConfig.env.NEXT_PUBLIC_ENVIRONMENT,
  tracesSampleRate: 1.0,
  // eslint-disable-next-line no-process-env
  release: process.env.RENDER_GIT_COMMIT,
});
